@if (user?.profile_picture) {
<img
  [conResolveLinkToFile]="$safeNavigationMigration(user?.profile_picture)"
  fileType="image"
  class="rounded-circle"
  height="{{ size }}"
  width="{{ size }}"
  [placement]="placement"
  [ngbTooltip]="showTooltip ? (tooltipPrefix ? tooltipPrefix + ' ' : '') + $safeNavigationMigration(user?.first_name) + ' ' + $safeNavigationMigration(user?.last_name) : ''"
  [container]="container"
/>
} @if (!user?.profile_picture) {
<con-icon-by-name
  iconName="user"
  [placement]="placement"
  [ngbTooltip]="showTooltip ? (tooltipPrefix ? tooltipPrefix + ' ' : '') + $safeNavigationMigration(user?.first_name) + ' ' + $safeNavigationMigration(user?.last_name) : ''"
  [container]="container"
></con-icon-by-name>
}
